export const GET_ALL_MODALS_DATA = 'GET_ALL_MODALS_DATA';
